import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalWindowParameters} from '../../modal-window-parameters';
import {ModalWindowResponse} from '../../modal-window-response';

@Component({
  selector: 'app-modal-window-top-up-balance',
  templateUrl: './modal-window-top-up-balance.component.html',
})
export class ModalWindowTopUpBalanceComponent {
  @Input() modalWindowParameters: ModalWindowParameters;
  @Output() modalWindowResponse: EventEmitter<ModalWindowResponse> = new EventEmitter<ModalWindowResponse>();

  constructor() {
  }

  closeWindow() {
    this.modalWindowResponse.next({confirmed: false});
  }
}
